import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'

export type { DialogProps as HeadlessDialogProps, DialogTitleProps as HeadlessDialogTitleProps } from '@headlessui/react'

export const HeadlessDialog = Object.assign(Dialog, {
  Panel: DialogPanel,
  Title: DialogTitle,
  Backdrop: DialogBackdrop
})
